import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { Rarity } from '#src/__generated__/globalTypes.ts';
import { withFragments } from '#src/lib/gql/index.ts';

import type { getCommonCardShardsCount_currentUser } from './__generated__/index.graphql.ts';

export const getCommonCardShardsCount = withFragments(
  (
    currentUser: Nullable<getCommonCardShardsCount_currentUser>,
    cardSet: Nullable<string>
  ) => {
    return (
      currentUser?.cardShardsChests?.find(
        chest =>
          chest.rarity === Rarity.common &&
          (chest.cardSet?.slug === cardSet ||
            (chest.cardSet?.slug === 'common-base-set' && !cardSet))
      )?.cardShardsCount || 0
    );
  },
  {
    currentUser: gql`
      fragment getCommonCardShardsCount_currentUser on CurrentUser {
        slug
        cardShardsChests(
          sport: $sport
          rarities: [common, limited, rare, super_rare, unique]
        ) {
          id
          rarity
          cardShardsCount
          cardSet {
            slug
          }
        }
      }
    ` as TypedDocumentNode<getCommonCardShardsCount_currentUser>,
  }
);
